<div class="fixed inset-0 bg-gray-700 bg-opacity-75 flex justify-center items-center z-20 no-scrollbar">
    <div class="bg-white shadow-lg rounded p-4 max-w-md w-full relative">
        <h1 class="font-bold text-xl">{{title}}</h1>
        <p class="mt-1 text-primary-300 text-sm">{{description}}</p>
        <div class="my-4">
            <select (change)="onChangeOption($event)"
                class="px-2 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:ring-0 focus:outline-none w-full ease-linear transition-all duration-150">
                @for (item of faculty; track item.memberId) {
                <option [selected]="selectedOption == item.memberId" [value]="item.memberId">
                    <div class="flex items-center gap-2">
                        <div class="flex-1 inline-flex flex-span text-sm text-blueGray-600">
                            <span>{{item.name}}</span>
                        </div>
                    </div>
                </option>
                }
                <option [selected]="selectedOption == 'unassigned'" value="unassigned">Unassigned</option>
            </select>
        </div>
        <div class="flex flex-row gap-4 justify-end">
            <button type="button" (click)="onCancel()"
                class="text-primary-500 px-4 py-2 focus:outline-none">Cancel</button>
            <app-btn-action [label]="action" (clicked)="submit()" [inProgress]="working"
                bgColor="bg-primary-500 hover:bg-primary-700 disabled:bg-primary-200 active:bg-secondary-500">
            </app-btn-action>
        </div>
    </div>
</div>